import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTruckIconSecondary from './svgs/TruckIconSecondary.js';
import SvgTruckIcon from './svgs/TruckIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var truckIcon = (props => useIcon(SvgTruckIcon, SvgTruckIconSecondary, props));

export { truckIcon as default };
